/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export const FulfillmentProvider = {
	MerchantApp: 'MERCHANT_APP'
} as const
export type FulfillmentProviderType = (typeof FulfillmentProvider)[keyof typeof FulfillmentProvider]
export type Amount = {
	value: number
	precision: number
}
export const PaymentProvider = {
	AdyenTerminal: 'ADYEN_TERMINAL',
	AdyenEcom: 'ADYEN_ECOM',
	BlikkEcom: 'BLIKK_ECOM',
	BlikkPos: 'BLIKK_POS',
	Cash: 'CASH',
	BusinessCard: 'BUSINESS_CARD',
	GiftCard: 'GIFT_CARD',
	LoyaltyPoints: 'LOYALTY_POINTS',
	VippsMobilepay: 'VIPPS_MOBILEPAY',
	NetsTerminal: 'NETS_TERMINAL',
	VerifoneCheckout: 'VERIFONE_CHECKOUT',
	VerifoneEcom: 'VERIFONE_ECOM',
	StraumurEcom: 'STRAUMUR_ECOM',
	RapydCloudlink: 'RAPYD_CLOUDLINK',
	RapydAppToApp: 'RAPYD_APP_TO_APP',
	TeyaPoslink: 'TEYA_POSLINK',
	VerifonePosCloud: 'VERIFONE_POS_CLOUD'
} as const
export type PaymentProviderType = (typeof PaymentProvider)[keyof typeof PaymentProvider]
export const PaymentMethod = {
	SavedToken: 'SAVED_TOKEN',
	CashInstant: 'CASH_INSTANT',
	CashAsync: 'CASH_ASYNC',
	VerifoneEcomCard: 'VERIFONE_ECOM_CARD',
	VerifoneEcomToken: 'VERIFONE_ECOM_TOKEN',
	VerifoneEcomApplePay: 'VERIFONE_ECOM_APPLE_PAY',
	VerifoneEcomGooglePay: 'VERIFONE_ECOM_GOOGLE_PAY',
	VerifoneEcomCardCapture: 'VERIFONE_ECOM_CARD_CAPTURE',
	VerifoneCheckoutCard: 'VERIFONE_CHECKOUT_CARD',
	VerifoneCheckoutToken: 'VERIFONE_CHECKOUT_TOKEN',
	AdyenEcomCard: 'ADYEN_ECOM_CARD',
	AdyenTerminalApplePay: 'ADYEN_TERMINAL_APPLE_PAY',
	AdyenTerminalGooglePay: 'ADYEN_TERMINAL_GOOGLE_PAY'
} as const
export type PaymentMethodType = (typeof PaymentMethod)[keyof typeof PaymentMethod]
export const PricingMethod = {
	PerUnit: 'PER_UNIT',
	PerWeight: 'PER_WEIGHT',
	WeightEmbedded: 'WEIGHT_EMBEDDED',
	PriceEmbedded: 'PRICE_EMBEDDED'
} as const
export type PricingMethodType = (typeof PricingMethod)[keyof typeof PricingMethod]
export const AssetCategory = {
	Product: 'PRODUCT',
	Marketing: 'MARKETING'
} as const
export type AssetCategoryType = (typeof AssetCategory)[keyof typeof AssetCategory]
export const AssetStatus = {
	PendingUpload: 'PENDING_UPLOAD',
	Uploaded: 'UPLOADED',
	Processing: 'PROCESSING',
	Ready: 'READY',
	Failed: 'FAILED'
} as const
export type AssetStatusType = (typeof AssetStatus)[keyof typeof AssetStatus]
export const AssetVariantType = {
	Original: 'ORIGINAL',
	Thumbnail: 'THUMBNAIL',
	Small: 'SMALL',
	Medium: 'MEDIUM',
	Large: 'LARGE'
} as const
export type AssetVariantTypeType = (typeof AssetVariantType)[keyof typeof AssetVariantType]
export type AssetVariant = {
	type: AssetVariantTypeType
	url: string
	width?: number
	height?: number
	size: number
	contentType: string
}
export const AssetUsageKind = {
	Product: 'PRODUCT',
	ProductGroup: 'PRODUCT_GROUP',
	ProductCategory: 'PRODUCT_CATEGORY',
	MarketingContent: 'MARKETING_CONTENT',
	FeedLayout: 'FEED_LAYOUT'
} as const
export type AssetUsageKindType = (typeof AssetUsageKind)[keyof typeof AssetUsageKind]
export type AssetUsage = {
	kind: AssetUsageKindType
	uuid: string
	name: string
}
export type Asset = {
	uuid: string
	category: AssetCategoryType
	status: AssetStatusType
	tags: string[]
	filename: string
	width?: number
	height?: number
	hasAlpha?: boolean
	blurhash?: string
	processingError?: string
	variants: AssetVariant[]
	usages?: AssetUsage[]
	createdAt: number
	updatedAt: number
}
export type TaxAmount = {
	gross: Amount
	tax: Amount
	net: Amount
}
export const AssetUsageFilter = {
	Unused: 'UNUSED',
	Product: 'PRODUCT',
	ProductGroup: 'PRODUCT_GROUP',
	ProductCategory: 'PRODUCT_CATEGORY',
	MarketingContent: 'MARKETING_CONTENT',
	FeedLayout: 'FEED_LAYOUT'
} as const
export type AssetUsageFilterType = (typeof AssetUsageFilter)[keyof typeof AssetUsageFilter]
export const OrderPaymentStatus = {
	Unpaid: 'UNPAID',
	Pending: 'PENDING',
	Paid: 'PAID',
	PartiallyPaid: 'PARTIALLY_PAID',
	Overpaid: 'OVERPAID',
	Refunded: 'REFUNDED',
	PartiallyRefunded: 'PARTIALLY_REFUNDED'
} as const
export type OrderPaymentStatusType = (typeof OrderPaymentStatus)[keyof typeof OrderPaymentStatus]
export const OrderBagCheckStatus = {
	NotDetermined: 'NOT_DETERMINED',
	NotNeeded: 'NOT_NEEDED',
	Needed: 'NEEDED',
	Checked: 'CHECKED',
	Rejected: 'REJECTED'
} as const
export type OrderBagCheckStatusType = (typeof OrderBagCheckStatus)[keyof typeof OrderBagCheckStatus]
export const OrderCheckoutStatus = {
	NotNeeded: 'NOT_NEEDED',
	Needed: 'NEEDED',
	Completed: 'COMPLETED'
} as const
export type OrderCheckoutStatusType = (typeof OrderCheckoutStatus)[keyof typeof OrderCheckoutStatus]
export const FulfillmentStatus = {
	NotNeeded: 'NOT_NEEDED',
	NotFulfilled: 'NOT_FULFILLED',
	PartiallyFulfilled: 'PARTIALLY_FULFILLED',
	Fulfilled: 'FULFILLED'
} as const
export type FulfillmentStatusType = (typeof FulfillmentStatus)[keyof typeof FulfillmentStatus]
export type GenericSuccess = {
	success: true
}
export type AppUpdateBranch = {
	name: string
	isPr: boolean
	latestUpdateAt: number | null
	updateCount: number
}
export type AppUpdate = {
	id: string
	branchName: string
	createdAt: number
	message: string | null
	runtimeVersion: string
	gitCommitHash: string | null
	fingerprint: string | null
}

export const zFulfillmentProvider = z.enum(['MERCHANT_APP'])
export const zAmount = z.object({
	value: z.number(),
	precision: z.number()
})
export const zPaymentProvider = z.enum([
	'ADYEN_TERMINAL',
	'ADYEN_ECOM',
	'BLIKK_ECOM',
	'BLIKK_POS',
	'CASH',
	'BUSINESS_CARD',
	'GIFT_CARD',
	'LOYALTY_POINTS',
	'VIPPS_MOBILEPAY',
	'NETS_TERMINAL',
	'VERIFONE_CHECKOUT',
	'VERIFONE_ECOM',
	'STRAUMUR_ECOM',
	'RAPYD_CLOUDLINK',
	'RAPYD_APP_TO_APP',
	'TEYA_POSLINK',
	'VERIFONE_POS_CLOUD'
])
export const zPaymentMethod = z.enum([
	'SAVED_TOKEN',
	'CASH_INSTANT',
	'CASH_ASYNC',
	'VERIFONE_ECOM_CARD',
	'VERIFONE_ECOM_TOKEN',
	'VERIFONE_ECOM_APPLE_PAY',
	'VERIFONE_ECOM_GOOGLE_PAY',
	'VERIFONE_ECOM_CARD_CAPTURE',
	'VERIFONE_CHECKOUT_CARD',
	'VERIFONE_CHECKOUT_TOKEN',
	'ADYEN_ECOM_CARD',
	'ADYEN_TERMINAL_APPLE_PAY',
	'ADYEN_TERMINAL_GOOGLE_PAY'
])
export const zPricingMethod = z.enum(['PER_UNIT', 'PER_WEIGHT', 'WEIGHT_EMBEDDED', 'PRICE_EMBEDDED'])
export const zAssetCategory = z.enum(['PRODUCT', 'MARKETING'])
export const zAssetStatus = z.enum(['PENDING_UPLOAD', 'UPLOADED', 'PROCESSING', 'READY', 'FAILED'])
export const zAssetVariantType = z.enum(['ORIGINAL', 'THUMBNAIL', 'SMALL', 'MEDIUM', 'LARGE'])
export const zAssetVariant = z.object({
	type: zAssetVariantType,
	url: z.string(),
	width: z.number().optional(),
	height: z.number().optional(),
	size: z.number(),
	contentType: z.string()
})
export const zAssetUsageKind = z.enum([
	'PRODUCT',
	'PRODUCT_GROUP',
	'PRODUCT_CATEGORY',
	'MARKETING_CONTENT',
	'FEED_LAYOUT'
])
export const zAssetUsage = z.object({
	kind: zAssetUsageKind,
	uuid: z.string(),
	name: z.string()
})
export const zAsset = z.object({
	uuid: z.string(),
	category: zAssetCategory,
	status: zAssetStatus,
	tags: z.array(z.string()),
	filename: z.string(),
	width: z.number().optional(),
	height: z.number().optional(),
	hasAlpha: z.boolean().optional(),
	blurhash: z.string().optional(),
	processingError: z.string().optional(),
	variants: z.array(zAssetVariant),
	usages: z.array(zAssetUsage).optional(),
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zTaxAmount = z.object({
	gross: zAmount,
	tax: zAmount,
	net: zAmount
})
export const zAssetUsageFilter = z.enum([
	'UNUSED',
	'PRODUCT',
	'PRODUCT_GROUP',
	'PRODUCT_CATEGORY',
	'MARKETING_CONTENT',
	'FEED_LAYOUT'
])
export const zOrderPaymentStatus = z.enum([
	'UNPAID',
	'PENDING',
	'PAID',
	'PARTIALLY_PAID',
	'OVERPAID',
	'REFUNDED',
	'PARTIALLY_REFUNDED'
])
export const zOrderBagCheckStatus = z.enum(['NOT_DETERMINED', 'NOT_NEEDED', 'NEEDED', 'CHECKED', 'REJECTED'])
export const zOrderCheckoutStatus = z.enum(['NOT_NEEDED', 'NEEDED', 'COMPLETED'])
export const zFulfillmentStatus = z.enum(['NOT_NEEDED', 'NOT_FULFILLED', 'PARTIALLY_FULFILLED', 'FULFILLED'])
export const zGenericSuccess = z.object({
	success: z.literal(true)
})
export const zAppUpdateBranch = z.object({
	name: z.string(),
	isPr: z.boolean(),
	latestUpdateAt: z.number().nullable(),
	updateCount: z.number()
})
export const zAppUpdate = z.object({
	id: z.string(),
	branchName: z.string(),
	createdAt: z.number(),
	message: z.string().nullable(),
	runtimeVersion: z.string(),
	gitCommitHash: z.string().nullable(),
	fingerprint: z.string().nullable()
})
